import React, { useEffect } from 'react';
import {
    Box,
    TextField,
    Divider,
    CircularProgress,
    // Typography,
    // Button
} from '@mui/material';
import RouteConstants from '../../constants/routeConstants';
import { makeStyles } from '@mui/styles';
import { FULL_PERMISSION } from '../../constants/Constant';
import { useState, Downgraded, createState } from '@hookstate/core';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import Title from '../../sharedcomponents/title/title';
import { useEventState } from '../../stores/eventStore';
import Helper from '../../utility/helper';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
// import IconPencil from '../../assets/images/Icon_Pencil.svg';
// import trash from '../../assets/images/trash.svg';
import AddTicketSetting from './addTicketSetting';
import { generatePath } from 'react-router-dom';

const useStyles = makeStyles({
    mobileLogo: {
        height: 42,
    },
    sedanBlack: {
        height: 18,
        width: 36,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
});
const ticketSettingState = createState({
    paid: '',
    comp: '',
});
const TicketSettings = (props) => {
    const classes = useStyles();
    const state = useState(ticketSettingState);
    const loading = useState(false);
    const [modPermission, setModPermission] = React.useState(null);
    const eventState = useEventState();
    const openTicketTypeDialog = useState(false);
    const eventData = useState(null);
    const [ticketInfo, setTicketInfo] = React.useState(null);
    const selectedTicketInfo = useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');

        if (eventState.get() && eventState.eventDetail.get() != null) {
            if (!Helper.isAdminUser(userInfo)) {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(permissions, 'HOTEL')
                    );
                }
            } else if (Helper.isAdminUser(userInfo)) {
                setModPermission(FULL_PERMISSION);
            }
        }
    }, [eventState]);
    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        if (
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        ) {
            eventData.set(eventInfo);
        }
    }, [])
    useEffect(() => {
        getTicketConfig();
    }, []);

    const getTicketConfig = () => {
        const eventInfo = Helper.getStorage('eventInfo');
        ApiHelper.get(
            APIURLConstants.GET_TICKET_CONFIG(eventInfo.eventID, 8)
        ).then((res) => {
            // console.log('res.data', res.data);
            if (res) {
                state.comp.set(res.data.comp);
                state.paid.set(res.data.paid);
                setTicketInfo(res.data)
            }
        });
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const eventInfo = Helper.getStorage('eventInfo');

        let payLoad = {
            eventTagDefaultID: ticketInfo != null ? ticketInfo.eventTagDefaultID : 0,
            eventID: eventData.get().eventID,
            moduleID: ticketInfo != null ? ticketInfo.moduleID : 0,
            tagID: ticketInfo != null ? ticketInfo.tagID : 0,
            pref: ticketInfo != null ? ticketInfo.pref : 0,
            comp: state.get().comp,
            paid: state.get().paid,
            ticketJSON: ticketInfo != null ? ticketInfo.ticketJSON : null,
            createdBy: 0,
            createdByName: "string",
        }
        ApiHelper.post(APIURLConstants.POST_TICKET_CONFIG, payLoad)
            .then(result => {
                if (result.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Status updated successfully',
                    });
                    setTimeout(() => {
                        props.history.push(
                            generatePath(RouteConstants.EVENT_TICKETS, {
                                eventID: eventInfo.eventID,
                            })
                        );
                    }, 1000);

                }
            }).catch(err => {
                console.log(err)
            })

    };
    const handleBtnCancel = () => {
        props.history.goBack();
    };
    // const handleOccupantCounter = () =>
    // {
    //     openTicketTypeDialog.set(true);
    // };
    const handleClose = () => {
        openTicketTypeDialog.set(false);
        selectedTicketInfo.set(null);

    };

    // const editTicket = (item) =>
    // {
    //     selectedTicketInfo.set(item);
    //     openTicketTypeDialog.set(true);
    // }

    return (
        <>
            {loading.get() ? (
                <Box className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : modPermission && modPermission != FULL_PERMISSION ? (
                <UnauthorizedUI showLogout={false} />
            ) : (
                <Box
                    className="contentBox"
                    style={{ paddingLeft: '24px', paddingRight: '24px' }}>
                    <Box
                        sx={{
                            width: '100%',
                            backgroundColor: '#fff',
                            '& .MuiFormControl-root': { width: '100%' },
                        }}>
                        <Box
                            component="form"
                            sx={{
                                width: '100%',
                                backgroundColor: '#fff',
                                '& .MuiFormControl-root': { width: '100%' },
                            }}
                            onSubmit={handleSubmit}>
                            <Box>
                                <Title title="Ticket Setting Form" />
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: {
                                        xs: 'column',
                                        md: 'row',
                                    },
                                    padding: 0,
                                    flex: 1,
                                    marginTop: 1,
                                    mb: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        flex: 0.5,
                                        alignItems: 'center',
                                        padding: 1,
                                    }}>
                                    <TextField
                                        required
                                        size="small"
                                        id="outlined-required"
                                        label="Comp"
                                        type={'number'}
                                        autoComplete="off"
                                        value={state.comp.get()}
                                        onChange={(event) => {
                                            state.comp.set(event.target.value);
                                        }}
                                        inputProps={{ maxLength: 50 }}
                                    />
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        flex: 0.5,
                                        alignItems: 'center',
                                        padding: 1,
                                    }}>
                                    <TextField
                                        required
                                        size="small"
                                        id="outlined-required"
                                        label="Paid"
                                        type={'number'}
                                        autoComplete="off"
                                        value={state.paid.get()}
                                        onChange={(event) => {
                                            state.paid.set(event.target.value);
                                        }}
                                        inputProps={{ maxLength: 50 }}
                                    />
                                </Box>
                            </Box>
                            {/* <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    // alignItems: 'center',
                                    justifyContent: 'space-between',
                                    backgroundColor: '#f8f8f8',
                                    flex: 2,
                                    marginBottom: 1,
                                }}>
                                <Box sx={{ padding: 1 }}>
                                    <Button
                                        variant="contained"
                                        onClick={handleOccupantCounter}
                                        color="primary">
                                        Add Ticket Price
                                    </Button>
                                </Box>
                            </Box> */}
                            {/* <Box>
                                {state.ticketSetting.attach(Downgraded).get()
                                    .length > 0 &&
                                    state.ticketSetting
                                        .attach(Downgraded)
                                        .get()
                                        .map((field, idx) =>
                                        {
                                            return (
                                                <Box
                                                    key={idx}
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        justifyContent:
                                                            'space-between',
                                                        flex: 1,
                                                        marginTop: 1,
                                                        backgroundColor:
                                                            '#f8f8f8',
                                                    }}>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'row',
                                                        }}>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                flexDirection:
                                                                    'column',
                                                                justifyContent:
                                                                    'start',
                                                                lineHeight: '0',
                                                            }}>
                                                            <Typography
                                                                variant="h2"
                                                                fontSize={12}
                                                                fontWeight={500}
                                                                paddingLeft={1}
                                                                paddingTop={1}
                                                                sx={{
                                                                    paddingLeft: 5,
                                                                }}
                                                                color={
                                                                    'primary'
                                                                }
                                                                pb={1}>
                                                                Ticket Type
                                                            </Typography>
                                                            <Typography
                                                                variant="h2"
                                                                fontSize={14}
                                                                fontWeight={400}
                                                                paddingLeft={1}
                                                                paddingTop={1}
                                                                sx={{
                                                                    paddingLeft: 5,
                                                                }}
                                                                pb={1}>
                                                                {
                                                                    field.ticketType
                                                                }
                                                            </Typography>
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                flexDirection:
                                                                    'column',
                                                                justifyContent:
                                                                    'start',
                                                                lineHeight: '0',
                                                            }}>
                                                            <Typography
                                                                variant="h2"
                                                                fontSize={12}
                                                                fontWeight={500}
                                                                paddingLeft={1}
                                                                paddingTop={1}
                                                                sx={{
                                                                    paddingLeft: 5,
                                                                }}
                                                                color={
                                                                    'primary'
                                                                }
                                                                pb={1}>
                                                                Ticket Cost
                                                            </Typography>
                                                            <Typography
                                                                variant="h2"
                                                                fontSize={14}
                                                                fontWeight={400}
                                                                paddingLeft={1}
                                                                paddingTop={1}
                                                                sx={{
                                                                    paddingLeft: 5,
                                                                }}
                                                                pb={1}>
                                                                {
                                                                    field.ticketPrice
                                                                }
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'row',
                                                        }}>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                flexDirection:
                                                                    'row',
                                                                alignItems:
                                                                    'center',
                                                                justifyContent:
                                                                    'flex-end',
                                                            }}>
                                                            <Box
                                                                sx={{
                                                                    display:
                                                                        'flex',
                                                                    alignItems:
                                                                        'center',
                                                                    flex: 0.05,
                                                                }}>
                                                                <Box
                                                                    component="img"
                                                                    className={
                                                                        classes.sedanBlack
                                                                    }
                                                                    onClick={() => editTicket(field)}
                                                                    alt="logo."
                                                                    src={
                                                                        IconPencil
                                                                    }
                                                                    //   onClick={() =>
                                                                    //       handleOccupantEditData(
                                                                    //           field.firstName,
                                                                    //           field.lastName,
                                                                    //           field.relation,
                                                                    //           idx
                                                                    //       )
                                                                    //   }
                                                                    sx={{ cursor: 'pointer' }}
                                                                />
                                                            </Box>
                                                            <Box
                                                                sx={{
                                                                    display:
                                                                        'flex',
                                                                    alignItems:
                                                                        'center',
                                                                    flex: 0.05,
                                                                }}>
                                                                <Box
                                                                    component="img"
                                                                    className={
                                                                        classes.sedanBlack
                                                                    }
                                                                    alt="logo."
                                                                    sx={{ cursor: 'pointer' }}
                                                                    src={trash}
                                                                //   onClick={() =>
                                                                //       handleRemoveOccupant(
                                                                //           idx
                                                                //       )
                                                                //   }
                                                                />
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            );
                                        })}
                            </Box> */}
                            <Divider component="div" />
                            <ButtonContainer
                                //handleClick={handleClick}
                                handleCancel={handleBtnCancel}
                                buttonText={'Update'}
                                disableButton={state.isDisable.get()}
                            />
                        </Box>
                    </Box>
                </Box>
            )}
            {openTicketTypeDialog.get() && <AddTicketSetting
                ticketInfo={selectedTicketInfo
                    .attach(Downgraded)
                    .get()}
                title="Add Ticket Price"
                open={openTicketTypeDialog.get()}
                handleClose={handleClose}
                getNotification={getTicketConfig}
            // setSnackBarProps={setSnackBarProps}
            />}
        </>
    );
};
export default {
    routeProps: {
        path: [
            RouteConstants.EVENT_TICKET_SETTINGS,
            // RouteConstants.EDIT_HOTEL_EVENT,
        ],
        component: TicketSettings,
    },
    name: 'TicketSettings',
};
